/**
 * The DGI floor of the parameter tables, derived from the four annex
 * constants. Nothing here is a copy of a value: every row reads the
 * constant it stands for, so the constants stay the single source.
 */
import { CLIENT_TYPES } from "../constants/client-types.js";
import { ARTICLE_TYPES } from "../constants/article-types.js";
import { CREDIT_NOTE_TYPES } from "../constants/credit-note-types.js";
import { COMMENT_LINE_TYPES } from "../constants/comment-lines.js";
import { PARAMETER_TABLE_COLUMNS, } from "./types.js";
/** True when a text column carries no data. */
export function isBlank(value) {
    return value === undefined || value === null || value.trim() === "";
}
/** Columns of `table` that are blank on the given values. */
export function blankColumns(table, values) {
    return PARAMETER_TABLE_COLUMNS[table].filter((field) => isBlank(values[field]));
}
function dgiRow(table, code, values, attributes, position) {
    return {
        code,
        ...values,
        attributes,
        source: "DGI",
        fillableFields: blankColumns(table, values),
        position,
    };
}
const DGI_CLIENT_TYPES = Object.values(CLIENT_TYPES).map((type, index) => dgiRow("CLIENT_TYPE", type.code, {
    label: type.label,
    invoiceMention: type.invoiceMention,
    description: type.description,
    applicableCase: null,
}, {
    requiresName: type.requiresName,
    requiresIFU: type.requiresIFU,
    acceptsNIF: type.acceptsNIF,
}, index));
const DGI_ARTICLE_TYPES = Object.values(ARTICLE_TYPES).map((type, index) => dgiRow("ARTICLE_TYPE", type.code, {
    label: type.label,
    invoiceMention: type.invoiceMention,
    description: type.description,
    applicableCase: null,
}, { isService: type.isService, isImported: type.isImported }, index));
// The annex has a mention column for credit-note natures but the DGI rows
// leave it blank: the printed wording is the label.
const DGI_CREDIT_NOTE_TYPES = Object.values(CREDIT_NOTE_TYPES).map((type, index) => dgiRow("CREDIT_NOTE_TYPE", type.code, {
    label: type.label,
    invoiceMention: null,
    description: type.description,
    applicableCase: null,
}, { requiresOriginalInvoice: type.requiresOriginalInvoice }, index));
// The annex leaves « applicable dans le cas » to the company for every line,
// so it is blank on all eight DGI rows.
const DGI_COMMENT_LINE_TYPES = Object.values(COMMENT_LINE_TYPES).map((type, index) => dgiRow("COMMENT_LINE", type.code, {
    label: type.label,
    invoiceMention: null,
    description: type.description,
    applicableCase: null,
}, { isReserved: type.isReserved }, index));
/** The four tables exactly as the DGI annex defines them. */
export const DGI_PARAMETER_TABLES = {
    clientTypes: DGI_CLIENT_TYPES,
    articleTypes: DGI_ARTICLE_TYPES,
    creditNoteTypes: DGI_CREDIT_NOTE_TYPES,
    commentLineTypes: DGI_COMMENT_LINE_TYPES,
};
/** Property of ParameterTables holding each table. */
export const PARAMETER_TABLE_KEYS = {
    CLIENT_TYPE: "clientTypes",
    ARTICLE_TYPE: "articleTypes",
    CREDIT_NOTE_TYPE: "creditNoteTypes",
    COMMENT_LINE: "commentLineTypes",
};
/** Rows of one table, untyped on attributes. */
export function tableRows(tables, table) {
    return tables[PARAMETER_TABLE_KEYS[table]];
}
//# sourceMappingURL=dgi-tables.js.map